import { GETREMINDERLIST_SUCCESS, GETREMINDERLIST_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getReminderListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETREMINDERLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETREMINDERLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getReminderListReducer;
